import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/signIn';
import $R from 'plugins/tfs/platformConfigs/integrationMaps/routes';
import React, { useState, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { Redirect } from 'react-router-dom';

// pageContainer
import Login from '_pageContainers/login';

import { objectSelector } from 'theme/utils';
import AuthForm from 'theme/captchaAuth/AuthForm';
import Widget from 'theme/widgets';

const loginGrid = (pageContext) => {
  let currentStoreInformation = JSON.parse(localStorage.getItem('usedStorage'));

  const siteKey = process.env.REACT_APP_CAPTCHA_KEY;

  const {
    props: { success, pending, currentStore, error, staffs },
    onLogin,
  } = pageContext;

  const [loginError, setLoginError] = useState({ count: 0 });
  const [showButton, setShowButton] = useState(true);

  const storeName = objectSelector(
    currentStore,
    'name',
    objectSelector(currentStoreInformation, 'name', '')
  );

  const storeAddress = objectSelector(
    currentStore,
    'address.line',
    objectSelector(currentStoreInformation, 'address.line', '')
  );
  const townshipName = objectSelector(
    currentStore,
    'address.township.name',
    objectSelector(currentStoreInformation, 'address.township.name', '')
  );
  const townshipCityName = objectSelector(
    currentStore,
    'address.township.city.name',
    objectSelector(currentStoreInformation, 'address.township.city.name', '')
  );
  const email = objectSelector(
    currentStore,
    'email',
    objectSelector(currentStoreInformation, 'email', '')
  );

  useEffect(() => {
    if (Object.keys(error).length > 0) {
      setLoginError((prev) => ({ ...prev, count: prev.count + 1 }));
      if (loginError.count > 1) {
        setShowButton(false);
      }
    }
  }, [error]);

  function onChange() {
    setInterval(() => {
      setShowButton(true);
    }, 300);
  }

  if (success) {
    localStorage.setItem('localCurrentRetailStore', JSON.stringify(staffs));
    return <Redirect push to={$R.STAFF_SELECTION.path} />;
  }

  return (
    <div className='container-fluid headerMargin__onlyLogo'>
      <div className='row'>
        <div className='col-12 col-md-6'>
          <div className='row justify-content-md-center login_form-container'>
            <div className='col-12 col-md-8'>
              <div className='login_partial-container'>
                <h1>{$ST.SELECTED_STORE}</h1>
                <div className='addresses'>
                  <p className='address__title'>{storeName}</p>
                  <p className='address__content'>
                    {`
                        ${storeAddress}
                        ${townshipName}/
                        ${townshipCityName}`}
                  </p>
                </div>
              </div>
              <AuthForm
                authPending={pending}
                error={error}
                email={email}
                display={showButton}
                login={(formData) => {
                  onLogin(formData);
                }}
              />
              {loginError.count > 2 && (
                <div className='mt-2'>
                  <ReCAPTCHA sitekey={siteKey} hl={'nl'} onChange={onChange} />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='col-12 col-md-6 login_right-block'>
          <Widget path='login.login_banner' />
        </div>
      </div>
    </div>
  );
};

export default Login(loginGrid);



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/login/index.js